import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { SectionChiefInfo } from 'components/IAP/planningView/widgets/AssignmentList/useSectionChiefResolver';
import { selectIncidentGuid, useAppSelector } from 'slices/commonSelectors';
import config from 'constants/apiConfig';

export const keys = {
  sectionChief: 'sectionChief',
};

export const useResolveSectionChief = (targetWorkGroupId:string) => {
  const currentIncidentId = useAppSelector(selectIncidentGuid);

  const baseUrl = `${config.apiGateway.ics_work_assignment_list_attachment}/${currentIncidentId}`;

  return useQuery({
    queryKey: [keys.sectionChief, currentIncidentId],
    queryFn: async () => {
      const response = await axios.get(`${baseUrl}/sectionChiefInfo/${targetWorkGroupId}`);
      return response.data as SectionChiefInfo;
    },
    enabled: !!currentIncidentId,
  });
};
